import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useCreateDocumentFlag() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.createDocumentFlagDocumentsKeyFlagsPostMutation(),
    onSuccess: (data, variables) => {
      const options = apiClient.getDocumentFlagsDocumentsKeyFlagsGetOptions({
        path: { key: variables.path.key },
      })

      queryClient.setQueryData(
        options.queryKey,
        (old: apiClient.DocumentFlagsResponse | undefined) => {
          if (!old) return old
          return { ...old, items: [...old.items, data] }
        },
      )

      queryClient.invalidateQueries(options)
      queryClient.invalidateQueries(
        apiClient.getDocumentDocumentsKeyGetOptions({
          path: { key: variables.path.key },
        }),
      )
    },
  })
}
